/**
 * Objects Store Module
 *
 * Load GraphQL Objects Data
 */

// Dependencies
import Vue from 'vue'
import api from '@/lib/api'

// Types
import * as types from '@/lib/store/types'

// State
const state = {
	items: {},
	item: {},
	loading: 0,
	errors: {}
}

// Actions
const actions = {
	[types.LOAD_ITEMS] ({commit}, params)
	{
		let key = Object.keys(params)[0]
		let error = {}
		error[key] = null

		commit(types.SET_LOADING, true)
		commit(types.SET_ERROR, error)
		commit(types.SET_ITEMS, error)

	return api.request(params)
			.then( res => {
				commit(types.SET_ITEMS, res)
			})
			.catch( err => {
console.log( `${types.LOAD_ITEMS}.fail`, err)
				error[key] = err
				commit(types.SET_ERROR, error)
			})
			.then( () => {
				commit(types.SET_LOADING, false)
			})
	},

	[types.LOAD_ITEM] ({commit}, params)
	{
		let key = Object.keys(params)[0]
		let error = {}
		error[key] = null
		commit(types.SET_LOADING, true)
		commit(types.SET_ERROR, error)
		commit(types.SET_ITEM, error)

		return api.request(params)
			.then( res => {
				commit(types.SET_ITEM, res)
			})
			.catch( err => {
				error[key] = err
console.log( `${types.LOAD_ITEM}.fail`, err)
				commit(types.SET_ERROR, err)
			})
			.then( () => {
				commit(types.SET_LOADING, false)
			})
	}
}

const mutations = {
	[types.SET_ITEMS] (state, items)
	{
		let key = Object.keys(items)[0]
		Vue.set(state.items, key, items[key] )
	},

	[types.SET_ITEM] (state, item)
	{
		let key = Object.keys(item)[0]
		Vue.set(state.item, key, item[key] )
	},

	[types.SET_LOADING] (state, loading)
	{
		if( loading ) {
			state.loading++
		} else {
			state.loading--
		}
		Vue.set(state, 'loading', state.loading )
	},

	[types.SET_ERROR] (state, error)
	{
		let key = Object.keys(error)[0]
		Vue.set(state.errors, key, error[key] )
	}

}

const getters = {
	items: state => state.items,
	item: state => state.item,
	loading: (state) => {
		return !!state.loading
	}
}

export default {
	state,
	actions,
	mutations,
	getters
}


// WEBPACK FOOTER //
// ./src/lib/store/modules/Object.js